import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Skeleton,
} from '@all-manager/design-system-v2';
import { MouseEvent } from 'react';
import { QuoteGroupSummary } from '../../api/useGetQuoteGroups';
import QuoteGroupMenuAction from '../QuoteGroupMenuAction/QuoteGroupMenuAction';

type Props = {
  groups: QuoteGroupSummary[];
  isAdmin: boolean;
  getHref: (groupId: string) => string;
  onOpen: (event: MouseEvent<HTMLElement>, groupId: string) => void;
};

const SKELETON_ROWS = [0, 1, 2];

function formatQuoteCount(count: number) {
  if (count === 0) {
    return 'Aucun devis pour l\'instant';
  }

  return `${count} devis à comparer`;
}

export default function QuoteGroupList(props: Props) {
  return (
    <List disablePadding aria-label="Comparaisons de devis">
      {props.groups.map((group) => (
        <ListItem
          key={group.id}
          divider
          disablePadding
          secondaryAction={props.isAdmin ? (
            <QuoteGroupMenuAction groupId={group.id} groupName={group.name} />
          ) : undefined}
        >
          <ListItemButton
            href={props.getHref(group.id)}
            onClick={(event) => props.onOpen(event, group.id)}
          >
            <ListItemText primary={group.name} secondary={formatQuoteCount(group.quoteCount)} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}

export function QuoteGroupListSkeleton() {
  return (
    <List disablePadding aria-busy="true" aria-label="Chargement des comparaisons">
      {SKELETON_ROWS.map((row) => (
        <ListItem key={row} divider>
          <ListItemText
            primary={<Skeleton variant="text" width="40%" />}
            secondary={<Skeleton variant="text" width="20%" />}
          />
        </ListItem>
      ))}
    </List>
  );
}
